// Sidebar navigation map for the employee self-service portal. `story`
// cross-references the user story it implements in BrandonUserStoryAPI.md
// (EE-01 through EE-03).
export const NAV = [
  {
    section: 'My benefits',
    items: [
      { path: 'cover', label: 'Enrolment Overview', story: 'EE-01' },
      { path: 'scheme', label: 'Benefit details', story: 'EE-02' },
      { path: 'details', label: 'My details', story: 'EE-03' },
    ],
  },
];
